<template>
  <div class="w-full bg-brand-gray-150 p-2.5 pt-2 rounded-md flex flex-col">
    <div class="tabber pb-2 w-full flex overflow-x-auto">
      <button
        v-for="(tab, key) in tabs"
        :key="key"
        :class="{ 'text-primary border-b-2 border-primary': selectedTab.label == tab.label }"
        class="flex-none py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        @click="selectedTab = tab"
      >
        {{ $t(tab.label) }}
      </button>
    </div>
    <div>
      <component :is="selectedTab.component"></component>
    </div>
  </div>
</template>

<script setup>
import AlertsServices from '@/views/individual/dashboard/ServicesOverview/Alerts/index.vue'
import FavoriteServices from '@/views/individual/dashboard/ServicesOverview/Favorites/index.vue'
import NextActions from '@/views/individual/dashboard/ServicesOverview/NextActions/index.vue'
import RecentlyReleased from '@/views/individual/dashboard/ServicesOverview/RecentlyReleased/index.vue'
import RecentlyUsed from '@/views/individual/dashboard/ServicesOverview/RecentlyUsed/index.vue'
import { onMounted, ref } from 'vue'

const tabs = [
  {
    label: 'favouriteServices',
    component: FavoriteServices
  },
  {
    label: 'recentlyUsedServices',
    component: RecentlyUsed
  },
  {
    label: 'recentlyReleasedServices',
    component: RecentlyReleased
  },
  {
    label: 'alerts',
    component: AlertsServices
  },
  {
    label: 'whatIsNext',
    component: NextActions
  }
]

const selectedTab = ref(tabs[0])

onMounted(() => {})
</script>

<style lang="scss" scoped></style>
